import { render, staticRenderFns } from "./СourierMarker.vue?vue&type=template&id=6dc69872&"
import script from "./СourierMarker.vue?vue&type=script&lang=js&"
export * from "./СourierMarker.vue?vue&type=script&lang=js&"
import style0 from "./СourierMarker.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports